import { useEffect, useMemo } from "react";
import { Dialog, Box } from "@mui/material";

const buildContextShareUrl = (baseUrl, launchPath) => {
  try {
    const url = new URL(baseUrl);
    url.searchParams.set("embedded", "1");
    url.searchParams.set("source", "contextstory");
    url.searchParams.set(
      "launch_source",
      `${window.location.origin}${launchPath || window.location.pathname}`
    );
    url.searchParams.set(
      "return_url",
      `${window.location.origin}${launchPath || window.location.pathname}`
    );
    return url.toString();
  } catch (_error) {
    return baseUrl;
  }
};

const ContextSharePopup = ({ open, onClose, url, launchPath }) => {
  const iframeUrl = useMemo(() => buildContextShareUrl(url, launchPath), [url, launchPath]);

  useEffect(() => {
    if (!open) return undefined;

    let allowedOrigin = "";
    try {
      allowedOrigin = new URL(url).origin;
    } catch (_error) {}

    const handleMessage = (event) => {
      if (allowedOrigin && event.origin !== allowedOrigin) return;
      if (event?.data?.type === "contextshare-close") {
        onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [open, onClose, url]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={false}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: "100vw", sm: 640 },
          maxWidth: { xs: "100vw", sm: "92vw" },
          height: { xs: "100vh", sm: 500 },
          maxHeight: { xs: "100vh", sm: "92vh" },
          display: "flex",
          flexDirection: "column",
          borderRadius: { xs: 0, sm: 3 },
          overflow: "hidden",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(15, 23, 42, 0.42)",
        },
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          height: "100%",
          borderRadius: { xs: 0, sm: 3 },
          overflow: "hidden",
          backgroundColor: "transparent",
        }}
      >
        <iframe
          title="ContextShare"
          src={iframeUrl}
          style={{ width: "100%", height: "100%", border: "none", display: "block" }}
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </Box>
    </Dialog>
  );
};

export default ContextSharePopup;
